import axios from 'axios';
// const axios = require('axios');
let data = JSON.stringify({
  "data": {
    "prompt": "girl sitting in the playgorund ",
    "async_process": false
  }
});
var jsonData = {
  
    "data": {
        "prompt": "girl sitting in the playgorund ",
        "async_process": false
    }

}

let config = {
  method: 'post',
  maxBodyLength: Infinity,
  url: 'https://bharattube.aicte-india.org/api/generate-image/generate-image',
  // headers: { 
  //   'Content-Type': 'application/json'
  // },
  data : jsonData
};
async function requestImage(text) { 
axios.request(config)
.then((response) => {
  console.log(JSON.stringify(response.data));
  return JSON.stringify(response.data.base64);
})
.catch((error) => {
  console.log(error);
})
}
export default requestImage